const expList = [
    {
        "duration": "Jan, 2023 - Present",
        "position": "Software Development Engineer - I",
        "name": "JUSPAY, Mumbai",
        "desc": "Building high-performance payment solutions using Functional Programming and backend technologies. Working on fintech infrastructure with focus on reliability, security, and scalability."
    },
    {
        "duration": "September, 2022 - December, 2022",
        "position": "Teaching Assistant - Python",
        "name": "DY Patil International University, Pune",
        "desc": "Taught Python programming to 100+ undergraduate students. Conducted lectures, lab sessions, graded assignments, and provided academic support for data structures and algorithms."
    },
    {
        "duration": "May, 2022 - August, 2022",
        "position": "Backend Developer Intern",
        "name": "Frsh Technologies Pvt Ltd, Bangalore",
        "desc": "Developed RESTful APIs and microservices using Node.js. Performed database operations, conducted testing, and collaborated with frontend teams on full-stack applications."
    },
    {
        "duration": "May, 2021 - March, 2022",
        "position": "Software Developer Intern",
        "name": "Frsh Technologies Pvt Ltd, Bangalore",
        "desc": "Built meta search engines and web scraping solutions using Node.js and JavaScript. Created Chrome extensions to automate workflows and enhance browser functionality."
    },
    {
        "duration": "May, 2021 - Aug, 2021",
        "position": "Software Engineer Intern",
        "name": "Manastik Pvt Ltd, Pune",
        "desc": "Developed mobile applications using Flutter and integrated AWS services. Collaborated with development team on architecture decisions and performance optimization."
    },
    {
        "duration": "April, 2020 - May, 2020",
        "position": "Tech Content Writer & Proofreader",
        "name": "Essential Services Outsource Pvt Ltd, Delhi",
        "desc": "Created technical content on emerging technologies and industry trends. Reviewed websites and code documentation for quality assurance."
    }
]

export default expList;